<norupe-header />
<div class="absolute top-16 bottom-0 w-full">
  <div class="flex h-full flex-col lg:flex-row">
    <div class="lg:h-full lg:w-[24em] lg:flex-shrink-0 lg:shadow-2xl">
      <div class="hidden lg:block">
        <norupe-overview-sidemenu class="flex h-full w-full" />
      </div>

      <div class="p-4 lg:hidden">
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="ml-2">Filtri</span>
              </mat-panel-title>
              <mat-panel-description> Izvēlieties filtrus </mat-panel-description>
            </mat-expansion-panel-header>

            <norupe-overview-sidemenu />
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>

    <div class="h-full flex-1">
      <norupe-overview-table class="flex h-full w-full" />
    </div>
  </div>
</div>
